import React from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Lottie from "lottie-react";
import faqAnim from "../assets/faq.json";

const ACCENT = "#FF6B00";

const FAQS = [
  {
    q: "¿Qué garantía ofrece KW Solar?",
    a: "Paneles hasta 25 años y producción mínima garantizada por escrito.",
  },
  {
    q: "¿Puedo deducir mis paneles?",
    a: "Sí. Nuestros sistemas califican como inversión acelerada ante SAT (ISR 100 %).",
  },
  {
    q: "¿Qué cubre el mantenimiento?",
    a: "Limpieza, revisión de strings, pruebas termográficas y reporte anual.",
  },
  {
    q: "¿Atienden fuera de Hermosillo?",
    a: "Cubrimos todo el noroeste (MX) mediante cuadrillas móviles certificadas.",
  },
];

export default function FAQ() {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            mb: { xs: 3, md: 6 },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          Preguntas&nbsp;
          <Box component="span" sx={{ color: ACCENT }}>
            Frecuentes
          </Box>
        </Typography>

        <Stack direction={{ xs: "column", md: "row" }} spacing={4}>
          <Box
            sx={{ flex: 1, maxWidth: { md: "65%" }, mx: { xs: "auto", md: 0 } }}
          >
            {FAQS.map(({ q, a }) => (
              <Accordion
                key={q}
                disableGutters
                sx={{
                  mb: 3,
                  borderRadius: 3,
                  background: "#f6f6f6",
                  "&:before": { display: "none" },
                  boxShadow: "0 8px 24px rgba(0,0,0,.05)",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore sx={{ color: ACCENT }} />}
                  sx={{ px: { xs: 2, md: 4 }, py: 2 }}
                >
                  <Typography sx={{ fontWeight: 600 }}>{q}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    px: { xs: 2, md: 4 },
                    pb: 3,
                    bgcolor: "rgba(255,107,0,.05)",
                    borderTop: `2px solid ${ACCENT}`,
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    {a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>

          {isMdUp && (
            <Box
              sx={{
                flexBasis: "35%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box sx={{ width: 360 }}>
                <Lottie animationData={faqAnim} loop autoplay />
              </Box>
            </Box>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
